var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-rating',{class:{
    small: _vm.small,
    single: _vm.isSingle
  },style:(_vm.stylesTheme),attrs:{"max":_vm.max,"size":_vm.size,"value":_vm.value || 0,"icon":"icon-star"},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }